import { render, staticRenderFns } from "./CachePoliciesForm.vue?vue&type=template&id=da4a3a6a&scoped=true&"
import script from "./CachePoliciesForm.vue?vue&type=script&lang=js&"
export * from "./CachePoliciesForm.vue?vue&type=script&lang=js&"
import style0 from "./CachePoliciesForm.vue?vue&type=style&index=0&id=da4a3a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da4a3a6a",
  null
  
)

export default component.exports